import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import Amplify, { Logger } from 'aws-amplify';
import { authDecorator } from './auth.decorator';
var logger = new Logger('AmplifyService');
var AmplifyService = /** @class */ (function () {
    function AmplifyService() {
        this._authState = new Subject();
        this.authStateChange$ = this._authState.asObservable();
        authDecorator(this._authState);
        this._auth = Amplify.Auth;
        this._analytics = Amplify.Analytics;
        this._storage = Amplify.Storage;
        this._api = Amplify.API;
        this._cache = Amplify.Cache;
        this._pubsub = Amplify.PubSub;
        this._interactions = Amplify.Interactions;
        this._i18n = Amplify.I18n;
        this._logger = Amplify.Logger;
        this._xr = Amplify.XR;
    }
    AmplifyService.prototype.auth = function () { return this._auth; };
    AmplifyService.prototype.analytics = function () { return this._analytics; };
    AmplifyService.prototype.storage = function () { return this._storage; };
    AmplifyService.prototype.api = function () { return this._api; };
    AmplifyService.prototype.interactions = function () { return this._interactions; };
    AmplifyService.prototype.i18n = function () { return this._i18n; };
    AmplifyService.prototype.cache = function () { return this._cache; };
    AmplifyService.prototype.pubsub = function () { return this._pubsub; };
    AmplifyService.prototype.logger = function (name, level) { return new this._logger(name, level); };
    AmplifyService.prototype.xr = function () { return this._xr; };
    AmplifyService.prototype.authState = function () { return this._authState; };
    AmplifyService.prototype.setAuthState = function (state) { this._authState.next(state); };
    AmplifyService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    AmplifyService.ctorParameters = function () { return []; };
    return AmplifyService;
}());
export { AmplifyService };
//# sourceMappingURL=amplify.service.js.map